import { useGtm } from '@hooks/gtm/use-gtm'
import sha256 from 'crypto-js/sha256'
import { TradeDoublerEventData } from '@models/gtm'

interface OrderEventPayload {
  orderNumber: string
  orderValue: string
  email: string
  currency?: string
  voucher?: string | null
  eventTime?: string | null
}

interface Response {
  sendOrderData: (payload: OrderEventPayload) => void
}

export const useTradedoublerIntegrationOrderGtmEvents = (): Response => {
  const { sendEvent } = useGtm()

  const sendOrderData = ({ orderNumber, orderValue, email, currency, voucher, eventTime }: OrderEventPayload) => {
    const extid = sha256(email).toString()

    // eslint-disable-next-line no-console
    console.log('[Tradedoubler] sendOrderData called', { orderNumber, orderValue })
    // eslint-disable-next-line no-console
    console.log('[Tradedoubler] order payload', {
      orderNumber,
      orderValue,
      currency,
      voucher,
      eventTime,
      extid,
    })

    sendEvent<TradeDoublerEventData>({
      event: 'payment_success',
      order: {
        number: orderNumber,
        value: orderValue,
        extid,
        currency,
        voucher,
        eventTime,
      },
    })

    // eslint-disable-next-line no-console
    console.log('[Tradedoubler] payment_success pushed to dataLayer', {
      orderNumber,
      orderValue,
    })
  }

  return {
    sendOrderData,
  }
}
